import { render, staticRenderFns } from "./CouponPopUp.vue?vue&type=template&id=c449d9d2&scoped=true&"
import script from "./CouponPopUp.vue?vue&type=script&lang=js&"
export * from "./CouponPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c449d9d2",
  null
  
)

export default component.exports